import $ from 'jquery'
import SFetch from '@app/utils/sfetch'

export function getFields(endpointParams, sourceParams) {
  const params = {
    ...Silverfin.jsonParams,
    ledger_id: endpointParams.ledgerId,
    id: endpointParams.reconciliationTextId || endpointParams.accountEntryId,
    source: {
      ...sourceParams,
    },
    account_id: endpointParams.accountId,
    _options: true,
  }

  const routes = Silverfin.Routes
  const url =
    endpointParams.reconciliationTextId !== undefined
      ? routes.autoreconciliation_fields_reconciliation_text_path(params)
      : routes.autoreconciliation_fields_ledger_account_entry_path(params)

  return SFetch.json(url, { method: 'GET' }, { camelizeJSON: false })
}

export function autoreconcile(endpointParams, autoreconciliationParams) {
  const params = {
    ...Silverfin.jsonParams,
    ledger_id: endpointParams.ledgerId,
    workflow_id: endpointParams.workflowId,
    id: endpointParams.reconciliationTextId || endpointParams.accountEntryId,
    account_id: endpointParams.accountId,
    _options: true,
  }

  const routes = Silverfin.Routes
  const url =
    endpointParams.reconciliationTextId !== undefined
      ? routes.autoreconcile_reconciliation_text_path(params)
      : routes.autoreconcile_ledger_account_entry_path(params)

  return $.post(url, { autoreconciliation: autoreconciliationParams })
}
